import React from "react";
import Tooltip from 'rc-tooltip';
import AcquireWebComponent from "../framework/MaterialUI";
import { Row, Col, FullRow } from "../framework/Grid/";
import Select from "react-select";
import { isEmpty, isUndefined, find } from "lodash";
import "./insights.css";

class SiteDateSelector extends AcquireWebComponent {
  handleWebsiteChange(e) {
    this.props.websiteIdChanged(e.value);
  }
  handleDayRangeChange(e) {
    this.props.dayRangeChanged(e.value);
  }
  handleGranularityChange(e) {
    window.localStorage.setItem("__granularity__", e.value);
    if (this.props.granularityChanged) {
      this.props.granularityChanged(e.value);
    }
  }

  componentDidMount() {
    if (!this.props.dayRange) {
      if (this.props.dayRangeChanged) this.props.dayRangeChanged("last-7-days");
    }
    if (!this.props.granularity) {
      if (this.props.granularityChanged) this.props.granularityChanged("scale");
    }

    if (
      this.props.websiteIdChanged &&
      isUndefined(this.props.siteId) &&
      this.props.sites &&
      !isEmpty(this.props.sites)
    ) {
      this.props.websiteIdChanged(this.props.sites[0].value);
    }
  }

  componentWillUpdate(nextProps) {
    if (
      nextProps.siteId !== this.props.siteId ||
      this.props.sites !== nextProps.sites
    ) {
      if (isUndefined(nextProps.siteId) && !isEmpty(nextProps.sites)) {
        this.props.websiteIdChanged(nextProps.sites[0].value);
      }
    }
  }

  render() {
    const { sites, type, siteId, showGranularity } = this.props;

    const dayOptions = [
      { value: "today", label: "Today" },
      { value: "yesterday", label: "Yesterday" },
      { value: "last-7-days", label: "Last 7 days" },
      { value: "last-30-days", label: "Last 30 days" },
      { value: "last-60-days", label: "Last 60 days" },
      {
        value: "last-90-days",
        label: "Last 90 days",
      } /*,
			{ value: '180', label: 'Last 6 months' },
			{ value: '360', label: 'Year to date' }*/,
    ];
    const granularityOptions = [
      { value: "precision", label: "Precision" },
      { value: "scale", label: "Scale" },
    ];
    const site = find(sites, s => {
      return s.value === siteId;
    });
    const rows = (
      <div>
        <Row
          style={{
            paddingRight: "10px",
            paddingLeft: "0",
            marginBottom: "0",
            ...this.props.style,
          }}
        >
          <Col xs="8" sm="8" md="8" lg="8" className="date-site-container">
            <div
              style={{
                display: "inline-block",
                width: type === "larger" ? "400px" : "300px",
              }}
            >
              <div
                style={{
                  display: "inline-block",
                  position: "absolute",
                  top: "10px",
                }}
              >
                <strong>Website Name</strong>
              </div>
              {this.props.websiteIdChanged ? (
                <Select
                  className={
                    type === "larger"
                      ? "insights-site-selector website-selector left-130"
                      : "insights-site-selector website-selector left-110"
                  }
                  name=""
                  value={this.props.siteId ? this.props.siteId : 1}
                  clearable={false}
                  options={sites}
                  onChange={this.handleWebsiteChange.bind(this)}
                />
              ) : (
                <div
                  style={{
                    display: "inline-block",
                    position: "absolute",
                    top: "10px",
                    left: "150px",
                  }}
                >
                  {site ? site.label : ""}
                </div>
              )}
            </div>
            {!showGranularity && this.props.dayRange && (
              <div style={{ display: "inline-block", width: "250px" }}>
                <div
                  style={{
                    display: "inline-block",
                    position: "absolute",
                    top: "10px",
                  }}
                >
                  <strong>Date</strong>
                </div>
                <Select
                  className="insights-site-selector left-50"
                  name=""
                  value={
                    this.props.dayRange ? this.props.dayRange : "last-7-days"
                  }
                  clearable={false}
                  options={dayOptions}
                  onChange={this.handleDayRangeChange.bind(this)}
                />
              </div>
            )}
          </Col>
          <Col xs="4" sm="4" md="4" lg="4" className="pt-5 no-padding-right">
            {this.props.handlePdfDownload && (
              <button
                type="button"
                className="aw-btn pull-right"
                onClick={() => {
                  this.props.handlePdfDownload();
                }}
              >
                {this.props.downloadBtnText}
              </button>
            )}
            {this.props.handleSegmentCreation && (
                <Tooltip overlay={<div>This feature is currently unavailable. Please reach out to your account manager to request an audience file.</div>} placement="top">
                  <button
                      type="button"
                      className="aw-btn pull-right mr-20"
                      style={{textTransform: "none", background: 'lightgray', cursor: 'no-drop'}}
                  >
                    Create an Audience
                  </button>
                </Tooltip>
            )}
          </Col>
        </Row>
        {showGranularity && (
            <FullRow
                className={
                  "no-padding-left light-grey-top-border light-grey-bottom-border"
                }
            >
              {this.props.dayRange && (
                  <div style={{display: "inline-block", width: "340px"}}>
                    <div
                        style={{
                    display: "inline-block",
                  }}
                >
                  <strong>Date</strong>
                </div>
                <Select
                  className="insights-date-selector left-30"
                  name=""
                  value={
                    this.props.dayRange ? this.props.dayRange : "last-7-days"
                  }
                  clearable={false}
                  options={dayOptions}
                  onChange={this.handleDayRangeChange.bind(this)}
                />
              </div>
            )}
            <div style={{ display: " inline-block", width: "250px" }}>
              <div
                style={{
                  display: "inline-block",
                  position: "absolute",
                  top: "0px",
                }}
              >
                <strong>Granularity</strong>
                <Select
                  className="insights-granularity-selector left-30"
                  name=""
                  value={this.props.granularity}
                  clearable={false}
                  options={granularityOptions}
                  onChange={this.handleGranularityChange.bind(this)}
                />
              </div>
            </div>
          </FullRow>
        )}
      </div>
    );

    return rows;
  }
}

SiteDateSelector.propTypes = {
  websiteIdChanged: React.PropTypes.func,
  dayRangeChanged: React.PropTypes.func,
  granularityChanged: React.PropTypes.func,
  siteId: React.PropTypes.number,
  sites: React.PropTypes.array,
  dayRange: React.PropTypes.string,
  type: React.PropTypes.string,
  handlePdfDownload: React.PropTypes.func,
  downloadBtnText: React.PropTypes.string,
  showGranularity: React.PropTypes.bool.isRequired,
  granularity: React.PropTypes.string.isRequired,
};

SiteDateSelector.defaultProps = {
  downloadBtnText: "Download",
  showGranularity: false,
  granularity: "scale",
};

export default SiteDateSelector;



// WEBPACK FOOTER //
// ./src/components/Insights/SiteDateSelector.jsx